import { createAsyncThunk } from '@reduxjs/toolkit';
import { notify } from '@che-ins-ui/notification';
import { getErrorMessage, toErrorWithMessage, scrollToTop, } from '@/libs/helpers';
import { captureError } from '@/libs/helpers/utils';
import { get2FAParams } from '@/libs/orderCreation2FA/orderCreation2FA';
import { validateFlights } from '@/models/flights/validateFlights';
import { FLIGHT_DEPARTURE_MIN_TIME_ERROR } from '@/libs/validation/validateFlightDeparture';
import { flightsActions, FLIGHTS_STATE_NAMESPACE } from '@/models/flights';
import { MIN } from '@/libs/constants';
import { InsuranceStep, stepsActions } from '@/models/steps';
import { reachAnalyticsGoal, YANDEX_GOALS } from '@/libs/analytics';
import { getOrderBody } from './utils';
import { processActions } from './slice';
const getTransformedErrorMessage = (message) => {
    if (message.includes('AccessDeniedError: You dont have permission to view this resource.')) {
        return 'Упс! Что-то пошло не так. Попробуйте перезагрузить страницу и попробовать ещё раз.';
    }
    if (message.includes('AccessDeniedError: You dont have permission to view this resource')) {
        return message;
    }
    return message;
};
export const createOrder = createAsyncThunk('process/createOrder', async (_, store) => {
    try {
        store.dispatch(processActions.setIsOrderCreating(true));
        store.dispatch(flightsActions.setFlightsDirty());
        store.dispatch(flightsActions.setAllFlightsFieldsDirty());
        await store.dispatch(validateFlights());
        const { [FLIGHTS_STATE_NAMESPACE]: { isFlightsValidated, stepError }, } = store.getState();
        if (!isFlightsValidated) {
            store.dispatch(stepsActions._setStep(InsuranceStep.flights));
            scrollToTop({ behavior: 'auto' });
            throw new Error(stepError || FLIGHT_DEPARTURE_MIN_TIME_ERROR);
        }
        const body = await getOrderBody(store.getState());
        const response = await fetch(`${__API_URL__}flightDelay/order`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...(await get2FAParams()),
            },
            body: JSON.stringify(body),
        });
        const result = await response.json();
        if (response.status >= 400) {
            throw new Error(JSON.stringify(result));
        }
        else {
            reachAnalyticsGoal(YANDEX_GOALS.paymentPage);
            location.replace(result.paymentLink);
        }
    }
    catch (error) {
        captureError(toErrorWithMessage(error), 'process/createOrder');
        const errorMessage = getErrorMessage(error);
        const transformedErrorMessage = getTransformedErrorMessage(errorMessage);
        notify.error({
            title: 'Validation Error',
            message: transformedErrorMessage,
            autoClose: MIN,
        });
        console.error(error);
        throw new Error('process/createOrder');
    }
    finally {
        store.dispatch(processActions.setIsOrderCreating(false));
    }
});
